import { createSlice } from '@reduxjs/toolkit';
import {
  FETCH_ALL_REVIEWERS,
  BULK_ASSIGN,
  ACTIVATE_REVIEWERS,
  UPDATE_MANAGE_REVIEWER,
} from '../../../actions-index';
import { ERROR_CONSTS } from '../../../util/constants';
import { sortByAttribute } from '../../../util/functions';

// ---------------------------------------------------------------------------
// manageReviewersReducer slice
// ---------------------------------------------------------------------------
const manageReviewersInitialState = {
  reviewers: {
    status: '',
    alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
    data: [],
    type: FETCH_ALL_REVIEWERS,
  },
  bulkAssign: {
    status: '',
    alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
    data: [],
    type: BULK_ASSIGN,
  },
  reviewerStatus: {
    status: '',
    alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
    data: null,
    type: ACTIVATE_REVIEWERS,
  },
};

const manageReviewersSlice = createSlice({
  name: 'manageReviewersReducer',
  initialState: manageReviewersInitialState,
  reducers: {
    fetchAllReviewers(state, action) {
      let reviewers = action.payload.data;
      return {
        ...state,
        reviewers: {
          status: action.payload.status ?? '',
          alert: action.payload.alert ?? '',
          data: reviewers ? sortByAttribute(reviewers, 'lastName') : [],
          type: FETCH_ALL_REVIEWERS,
        },
      };
    },
    bulkAssign(state, action) {
      return {
        ...state,
        bulkAssign: {
          status: action.payload.status ?? '',
          alert: action.payload.alert ?? '',
          data: action.payload.data ?? null,
          type: BULK_ASSIGN,
        },
      };
    },
    updateReviewerGoals(state, action) {
      return {
        ...state,
        reviewers: {
          ...state.reviewers,
          data: state.reviewers.data.map((item) => {
            const reviewer = action.payload.reviewers.find((reviewer) => {
              return item.reviewerEmployeeId === reviewer.reviewerEmployeeId;
            });
            return reviewer ? { ...item, quota: reviewer.quota } : item;
          }),
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(FETCH_ALL_REVIEWERS, (state, action) => {
      return {
        ...state,
        reviewers: {
          ...state.reviewers,
          status: action.payload.status ?? '',
          alert: action.payload.alert ?? '',
          type: FETCH_ALL_REVIEWERS,
        },
      };
    });
  },
});

export const { fetchAllReviewers, bulkAssign, updateReviewerGoals } =
  manageReviewersSlice.actions;
export const manageReviewersReducer = manageReviewersSlice.reducer;

// ---------------------------------------------------------------------------
// ManageReaderReducer slice
// ---------------------------------------------------------------------------
const manageReaderInitialState = {
  reviewer: [],
  loading: false,
  error: null,
};

const manageReaderSlice = createSlice({
  name: 'ManageReaderReducer',
  initialState: manageReaderInitialState,
  reducers: {
    fetchOneReader(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { fetchOneReader } = manageReaderSlice.actions;
export const ManageReaderReducer = manageReaderSlice.reducer;

// ---------------------------------------------------------------------------
// updateManageReviewerReducer slice
// ---------------------------------------------------------------------------
const updateManageReviewerInitialState = {
  updateReviewer: {
    status: '',
    alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
    type: UPDATE_MANAGE_REVIEWER,
  },
};

const updateManageReviewerSlice = createSlice({
  name: 'updateManageReviewerReducer',
  initialState: updateManageReviewerInitialState,
  reducers: {
    updateManageReviewer(state, action) {
      return {
        ...state,
        updateReviewer: {
          status: action.payload.status,
          alert: action.payload.alert,
          type: UPDATE_MANAGE_REVIEWER,
        },
      };
    },
  },
  extraReducers: (builder) => {
    // Handle the legacy UPDATE_MANAGE_REVIEWER action type dispatched by
    // AlertBar dismiss flow (dispatches { type: item.type, payload: ... })
    builder.addCase(UPDATE_MANAGE_REVIEWER, (state, action) => {
      return {
        ...state,
        updateReviewer: {
          status: action.payload.status,
          alert: action.payload.alert,
          type: UPDATE_MANAGE_REVIEWER,
        },
      };
    });
  },
});

export const { updateManageReviewer } = updateManageReviewerSlice.actions;
export const updateManageReviewerReducer = updateManageReviewerSlice.reducer;
